
export const GET_EVENTFLOW_SUCCESS = "GET_EVENTFLOW_SUCCESS";
export const GET_EVENTFLOW_FAILED = "GET_EVENTFLOW_FAILED";
export const GET_EVENTFLOW_STARTED = "GET_EVENTFLOW_STARTED";

export const SAVE_EVENTFLOW_STARTED = "SAVE_EVENTFLOW_STARTED";
export const SAVE_EVENTFLOW_SUCCESS = "SAVE_EVENTFLOW_SUCCESS";
export const SAVE_EVENTFLOW_FAILED = "SAVE_EVENTFLOW_FAILED";

export const UPDATE_EVENTFLOW_STARTED = "UPDATE_EVENTFLOW_STARTED";
export const UPDATE_EVENTFLOW_SUCCESS = "UPDATE_EVENTFLOW_SUCCESS";
export const UPDATE_EVENTFLOW_FAILED = "UPDATE_EVENTFLOW_FAILED";
 
export interface IEventDetails {
    status: {
        statusCode: number,
        statusDisplay: string,
        statusValue: boolean
    };
    items: Array<any>;
    eventFlowInitiationCreateInput: {
        insert_datetime:Date,
        inserted_by:string,
        update_datetime:Date,
        updated_by:string
       
    };
    permission_id: number;
    isLoading: boolean;
    error: string;
}

export const geteventFlowInitiation = (permission_id: any) => {
    
    return {
        type: GET_EVENTFLOW_STARTED ,
        payload: 'Value',
        input:permission_id,   
    };
};


export const eventFlowInitiationCreate = (eventFlowInitiationCreateInput: any) => {
 
    return {
        type: SAVE_EVENTFLOW_STARTED,
        payload: 'status',
        input: eventFlowInitiationCreateInput
    };
};

export const eventFlowInitiationUpdate = (eventDataFlowCreateInput: any) => {
 
    return {
        type: UPDATE_EVENTFLOW_STARTED,
        payload: 'status',
        input: eventDataFlowCreateInput
    };
};